define('viewModels/widgets/TimeRangeView',[
    'lib/knockout',
    'lib/lodash4',
    'moment',
    'viewModels/ViewModel',
    'services/timeRangeSettingsService',
    'services/loggingService',
    'extensions/i18n/knockout.i18n'
], function (
    ko,
    _,
    moment,
    ViewModel,
    timeRangeSettingsService,
    LOG
    ) {
    'use strict';

    //
    // This function takes a 12hour base time and returns equivalent 24 hour base time
    //
    var get24HourBase = function(hour, amPm){
        if(amPm.toLowerCase() ==="am" || amPm.toLowerCase() ==="a"){
            if(hour==='12'){
                return '0';
            } else{
                return hour;
            }
        } else {
            if (hour==='12'){
                return hour;
            } else {
                return (parseInt(hour,10) + 12).toString(10);
            }
        }
    };

    /**
     * TimeRangeSelector view model used for historical table and data visualization
     * @param entityId - string representing the entityId (queue Id or agent Id etc...)
     * @type {*|void|Object}
     */
    var TimeRangeView = ViewModel.extend(function (entityId, options) {
        var self = this;

        var namespace = options && options.namespace;

        var HOURS         = ['12', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'];
        var MINUTES_START = ['00','30'];
        var MINUTES_END   = ['00','30'];
        var AMPM          = ['AM','PM'];
        var TIME_INTERVAL_SEPARATOR ="-";
        var DEFAULT_TIME_RANGE = "12:00 AM " + TIME_INTERVAL_SEPARATOR + " 12:00 AM";

        // Time Select Range Properties
        self.startHourOptions    = ko.observable(HOURS);
        self.startHourValue      = ko.observable('12').extend({notify : 'always'});
        self.startMinuteOptions  = ko.observable(MINUTES_START);
        self.startMinuteValue    = ko.observable('00').extend({notify : 'always'});
        self.startAMPMOptions    = ko.observable(AMPM);
        self.startAMPMValue      = ko.observable('AM').extend({notify : 'always'});

        self.endHourOptions      = ko.observable(HOURS);
        self.endHourValue        = ko.observable('12').extend({notify : 'always'});
        self.endMinuteOptions    = ko.observable(MINUTES_END);
        self.endMinuteValue      = ko.observable('00').extend({notify : 'always'});
        self.endAMPMOptions      = ko.observable(AMPM);
        self.endAMPMValue        = ko.observable('AM').extend({notify : 'always'});

        self.timeRangeSelectTitle= ko.i18n.renderString('timeRange.picker.select.timeRange');

        self.isLoaded                 = ko.observable(false);
        self.timeIntervalIsUpdating   = ko.observable(false);

        self.invalidInputFormat       = ko.observable(false).extend({notify: 'always'});
        self.timeInterval_LastValidValue = ko.observable();
        self.isPopoverOpen  = ko.observable(false);


        /**
         * Returns a string representing the time interval ex: 12:00 AM - 12:00 AM
         * @param startHour - String representing hour
         * @param startMinute - String representing minute
         * @param startAMPM - String representing 'am' or 'pm'
         * @param endHour  - String representing hour
         * @param endMinute - String representing minute
         * @param endAMPM - String representing 'am' or 'pm'
         * @returns {string}
         */
         self.getTimeIntervalString = function(startHour, startMinute, startAMPM, endHour, endMinute, endAMPM) {
            var startTime = moment();
            startTime.hour(get24HourBase(startHour, startAMPM));
            startTime.minute(startMinute);

            var endTime = moment();
            endTime.hour(get24HourBase(endHour, endAMPM));
            endTime.minute(endMinute);

            var formattedString    = ko.i18n.renderString("timeRange.picker.timeFormat");
            var formattedTimeStart = ko.i18n.formatDate(startTime.toDate(), formattedString,'en-US'); //TODO: For now forcing format to North America (12 hour format) - Need to parse other locale
            var formattedTimeEnd   = ko.i18n.formatDate(endTime.toDate(), formattedString, 'en-US');  //TODO: For now forcing format to North America (12 hour format) - Need to parse other locale

            return  formattedTimeStart + " " + TIME_INTERVAL_SEPARATOR + " " + formattedTimeEnd;
        };

        /**
         * Receives a time interval string as '12:00 AM - 12:00 PM' and returns null if string is not valid.
         * Otherwise returns object:
         * {
         *      start: {
         *          hour:
         *          minute:
         *          amPM:
         *      },
         *      end: {
         *          hour:
         *          minute:
         *          amPM:
         *      }
         * }
         * @param timeIntervalString
         * @returns {{start: {}, end: {}}}
         */
        self.parseTimeIntervalString = function(timeIntervalString){
            if (!_.hasValue(timeIntervalString)) {
                return null;
            }
            var timeIntervalObject = {
                start:{},
                end:{}
            };

            var valid = false;
            var intervalObj = timeIntervalString.split(TIME_INTERVAL_SEPARATOR);

            var startTimeMoment, endTimeMoment;
            if (intervalObj.length===2){
                var tempDateFormat     = 'MM-DD-YYYY';
                var tempDateTimeFormat = 'MM-DD-YYYY h:mm A';
                var tempDateString     = moment().format(tempDateFormat);
                startTimeMoment    = moment(tempDateString + " " + intervalObj[0].trim(), tempDateTimeFormat, 'en', true);
                endTimeMoment      = moment(tempDateString + " " + intervalObj[1].trim(), tempDateTimeFormat, 'en', true);

                if (startTimeMoment.isValid() &&
                    endTimeMoment.isValid() &&
                    startTimeMoment.format('A').length == 2 &&
                    endTimeMoment.format('A').length  == 2) {
                        valid = true;
                }
            }

            if (valid) {
                var hourValue = parseInt(startTimeMoment.format('hh'),10);
                timeIntervalObject.start.hour = hourValue <= 12 ? hourValue.toString(10) : (hourValue % 12).toString(10);
                timeIntervalObject.start.minute  = startTimeMoment.format('mm')+"";
                timeIntervalObject.start.amPm = startTimeMoment.format('A');

                hourValue = parseInt(endTimeMoment.format('hh'),10);
                timeIntervalObject.end.hour = hourValue <= 12 ? hourValue.toString(10) : (hourValue % 12).toString(10);
                timeIntervalObject.end.minute = endTimeMoment.format('mm')+"";
                timeIntervalObject.end.amPm = endTimeMoment.format('A');
            } else {
                timeIntervalObject = null;
            }

            return timeIntervalObject;
        };

        self.timeInterval = self.computed({
            read: function(){
                self.invalidInputFormat(false); // Format is always good coming from select boxes.
                return self.getTimeIntervalString(
                    self.startHourValue(),
                    self.startMinuteValue(),
                    self.startAMPMValue(),
                    self.endHourValue(),
                    self.endMinuteValue(),
                    self.endAMPMValue()
                );
            },
            write: function(value){
                var intervalObject = self.parseTimeIntervalString(value);
                if (intervalObject) {
                    self.invalidInputFormat(false);
                    var startTime = intervalObject.start;
                    self.startHourValue(startTime.hour);
                    self.startMinuteValue(startTime.minute);
                    self.startAMPMValue(startTime.amPm);

                    var endTime = intervalObject.end;
                    self.endHourValue(endTime.hour);
                    self.endMinuteValue(endTime.minute);
                    self.endAMPMValue(endTime.amPm);

                } else {
                    self.invalidInputFormat(true);
                }
            }
        }).extend({isTimeIntervalValid: {timeSeparator: TIME_INTERVAL_SEPARATOR}, notify: 'always'});

        self.isTimeIntervalValid = self.computed(function(){
            return self.timeInterval.isValid() && !self.invalidInputFormat();
        });

        self.subscribe(self.timeInterval,function(){
            self.timeIntervalIsUpdating(true);
        });

        self.resetTimeToDefault = function(){
            var intervalObject = self.parseTimeIntervalString(DEFAULT_TIME_RANGE);
            if (intervalObject) {
                var startTime = intervalObject.start;
                self.startHourValue(startTime.hour);
                self.startMinuteValue(startTime.minute);
                self.startAMPMValue(startTime.amPm);

                var endTime = intervalObject.end;
                self.endHourValue(endTime.hour);
                self.endMinuteValue(endTime.minute);
                self.endAMPMValue(endTime.amPm);

                self.timeInterval(DEFAULT_TIME_RANGE);
                self.endHourValue.valueHasMutated();
            }

            self.processApply();
        };

        self.onPopoverHidden = function(){
            var lastValidValue = self.timeInterval_LastValidValue();
            if (lastValidValue) {
                self.timeInterval(lastValidValue);
            }
        };

        /**
         * processApply will apply the user selected or typed in time. This function will make a local copy and
         * a server side copy of the applied valid time. The server side copy will be made only if saveTime is true.
         * @param saveTime - Boolean indicating if the time should be saved to the backend while being applied
         */
        self.processApply = function(saveTime) {
            if (self.timeInterval.isValid()){
                saveTime = _.hasValue(saveTime) ? saveTime : true;
                var value = self.timeInterval();

                self.timeInterval_LastValidValue(value);

                self.isPopoverOpen(false); // close popover
                self.timeIntervalIsUpdating(false); // no longer updating

                if (saveTime){
                    timeRangeSettingsService.setSettings(entityId, {'timeInterval':value}, namespace)
                        .catch(function(){
                            LOG.error("Failed to save queue time range settings.");
                        });
                }
            }
        };

        //Get settings for queue ID
        timeRangeSettingsService.getSettings(entityId, {'timeInterval':DEFAULT_TIME_RANGE}, namespace)
            .then(function(response){
                self.timeInterval_LastValidValue(response.timeInterval);

                var timeIntervalObj = self.parseTimeIntervalString(response.timeInterval);

                if(timeIntervalObj){
                    self.startAMPMValue(timeIntervalObj.start.amPm);
                    self.startMinuteValue(timeIntervalObj.start.minute);
                    self.startHourValue(timeIntervalObj.start.hour);

                    self.endAMPMValue(timeIntervalObj.end.amPm);
                    self.endMinuteValue(timeIntervalObj.end.minute);
                    self.endHourValue(timeIntervalObj.end.hour);
                }
            })
            .catch(function(){
                LOG.error("Failed to load time range.");
            })
            .finally(function(){
                self.isLoaded(true);  //whether it passes or fails set to true.
                self.timeIntervalIsUpdating(false); // no longer updating
                self.invalidInputFormat(false);  // We either have value from user setting or default value either way we are good to go.
            });
    });

    return TimeRangeView;
});

